import Vue from 'vue'
import axios from 'axios';
import { Message } from 'element-ui';

// 开发  development
// 生产  production
// console.log(Vue);
// let env = 'production'

if(!Vue.prototype.$axios){
    Vue.prototype.$axios=axios
    axios.defaults.timeout = 50000
    axios.defaults.headers['X-Auth-Grpid'] = process.env.NODE_ENV === 'development' ? '000321' : localStorage.getItem('grpid');
    axios.defaults.headers['X-Auth-ComId'] = process.env.NODE_ENV === 'development' ? '000321' : localStorage.getItem('comId');
    axios.defaults.headers['X-Auth-OpenId'] = '123'
    axios.defaults.headers['X-Auth-key'] = '0x84843A0239C734D6C74BEFC1563BB486';
    axios.defaults.headers['X-Auth-Source'] = 'pad';
    // 此处不分开发环境和线上环境地址，所以公共地址直接写死
    axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '/api' : 'https://hynotify.gshis.com/api',
    axios.interceptors.request.use(
        config => {
            // const token = localStorage.getItem('token');
            // token && (config.headers.Authorization = token);
            return config;
        },
        error => {
            return Promise.error(error);
    })
    // 响应拦截器
    axios.interceptors.response.use(
        response => {
            // 此处判断是为了兼容手持的的nfc刷卡和排除上传图片（response.config.data是formdata对象）
            const responseData = response.config.data && !(response.config.data instanceof FormData) && JSON.parse(response.config.data)
            if (response.status === 200 && response.data.code==1 ) {
                return Promise.resolve(response);
            } else {
              console.log("进去");
                Message({
                    message:(responseData&&responseData.errTip)||response.data.msg,
                    type:'error',
                    customClass:"custom-message"
                })
                return Promise.reject(response.data.msg);
            }
        },
        error => {
            Message({
                duration:2000,
                message:error||error.msg,
                type:'error',
                customClass:"custom-message"
            })
            return Promise.reject(error);
        }
    )
}
// const service = axios.create({
//     baseURL: process.env.NODE_ENV == 'development' ?'/api':'https://hynotify.gshis.com/api',
//     timeout: 100000
//   })

  // service.interceptors.request.use(
  //   config => {
  //       config.headers['X-Auth-Grpid'] = localStorage.getItem('grpid');
  //       config.headers['X-Auth-ComId'] = localStorage.getItem('comId');
  //       config.headers['X-Auth-OpenId'] = '123';
  //       config.headers['X-Auth-key'] = '0x84843A0239C734D6C74BEFC1563BB486';
  //       // config.headers['Content-Type'] = 'multipart/form-data';
  //     return config
  //   },
  //   error => {
  //     return Promise.reject(error)
  //   }
  // )

  // service.interceptors.response.use(
  //   response => {
  //       if (response.status === 200 && response.data.code==1 ) {
  //           return Promise.resolve(response);
  //       } else {
  //           Message({
  //               message:response.data.msg,
  //               type:'error',
  //               customClass:"custom-message"
  //           })
  //           return Promise.reject(response.data.msg);
  //       }
  //   },
  //   error => {
  //       Message({
  //           duration:2000,
  //           message:error||error.msg,
  //           type:'error',
  //           customClass:"custom-message"
  //       })
  //       return Promise.reject(error);
  //   }
  // )


export default {axios }







// WEBPACK FOOTER //
// ./src/request/http.js